import React from 'react';
import { AlertTriangle, CheckCircle2 } from 'lucide-react';

const TONES = { Upcoming: 'bg-gray-100 text-gray-700', 'In progress': 'bg-blue-100 text-blue-800', Completed: 'bg-green-100 text-green-800',
  'Not started': 'bg-amber-100 text-amber-800', Late: 'bg-orange-100 text-orange-800', Missed: 'bg-red-100 text-red-800', Cancelled: 'bg-gray-100 text-gray-500 line-through', Scheduled: 'bg-gray-100 text-gray-700' };

export const StatusChip = ({ status }) => <span className={`text-xs px-2 py-0.5 rounded-full font-semibold ${TONES[status] || TONES.Scheduled}`} data-testid="visit-status-chip">{status}</span>;

// Result of the clock-in location check against the patient's home address
export const GeoFlag = ({ geo, compact }) => {
  if (!geo) return compact ? null : <span className="text-gray-500">Checking distance from the patient's home…</span>;
  if (geo.status !== 'checked') return <span className="text-gray-500" data-testid="geo-flag-unknown">· {geo.status}</span>;
  return geo.offsite
    ? <span className="inline-flex items-center gap-0.5 text-red-700 font-semibold" data-testid="geo-flag-offsite"><AlertTriangle className="w-3 h-3" />{geo.miles} mi from home</span>
    : <span className="inline-flex items-center gap-0.5 text-green-700" data-testid="geo-flag-ok"><CheckCircle2 className="w-3 h-3" />{compact ? 'at home' : `At the patient's home (${geo.miles} mi)`}</span>;
};
